// What the server asks to act on an operation (routes/api/winery/operations.js and operationsV2.js,
// middleware/verifyPermission.js verifyPermissionScopedByType): the broad grant on the resource, or, failing
// that, the grant of the resource scoped to the TYPE of the operation (OPERATIONS_ANALYSIS, EXECUTE_ANALYSIS).
//   plan (create, update, duplicate, rollback)           OPERATIONS write
//   delete (cancel)                                      OPERATIONS delete
//   execute, start                                       EXECUTE write
// Starting a duration operation is part of executing it (server 2b12868: POST /operations/start/:id and
// /operations/v2/:id/start ask EXECUTE write, no longer OPERATIONS write): oenologists plan, operators run.
// `can` is usePermissions().can (the effective map). Without a type only the broad grant counts, as the server
// does when it cannot resolve one.

export const scopedResource = (resource, type) => `${resource}_${String(type).toUpperCase()}`;

const canOnOperation = (can, resource, action, type) =>
  can(resource, action) || (Boolean(type) && can(scopedResource(resource, type), action));

export const canPlanOperation = (can, type) => canOnOperation(can, "OPERATIONS", "write", type);

export const canDeleteOperation = (can, type) => canOnOperation(can, "OPERATIONS", "delete", type);

export const canExecuteOperation = (can, type) => canOnOperation(can, "EXECUTE", "write", type);

// Start (stabilization, filtering, homogenization, oxygenation, cryo maceration): the first step of running the
// operation, so the same grant as executing it. Kept as its own name so the start call sites do not read as "execute".
export const canStartOperation = (can, type) => canOnOperation(can, "EXECUTE", "write", type);
